export const defaultActiveFilter = 'all_templates';
export const exportStates = {
  EXPORT: 'export',
  SUCCESS: 'success',
  ERROR: 'error',
  NONE: 'none',
};
export const maxReferencePhotoUploadCount = 5;
export const templateView = Object.freeze({
  EDIT: 'edit',
  LIST: 'list',
  PREVIEW: 'preview',
  DELETE_TEMPLATE_CONFIRM: 'delete_template_confirm',
});
export const referencePhotosView = Object.freeze({
  CONFIRM_DELETE: 'CONFIRM_DELETE',
  PREVIEW: 'PREVIEW',
  UPLOAD: 'UPLOAD',
});
export const reorderTypes = Object.freeze({
  TASKS: 'tasks',
  SECTIONS: 'sections',
  TASK_TEMPLATES: 'task_templates',
  TASK_LIST_SECTION_TEMPLATES: 'task_list_section_templates',
});
export const TASKLIST_INCOMPLETE_TOGGLE_STORAGE_KEY =
  'tasklist-hide-completed-by-id';
